<template>
  <div class="recharge_left capital_first">
    <div class="transport">
      <div class="tranport_title">策略单号:{{order}}</div>
      <div class="tranport_content">
        <div class="history_title">
          <ul class="first">
            <li>
              <div>总策略资金</div>
              <div>{{total}}</div>
            </li>
            <li>
              <div>申请额度</div>
              <div>{{apply_quota}}</div>
            </li>
            <li>
              <div>风险保证金</div>
              <div>{{bond}}</div>
            </li>
          </ul>
          <ul>
            <li>
              <div>利益分配</div>
              <div>{{divided}}</div>
            </li>
            <li>
              <div>亏损警戒线</div>
              <div>{{warning}}</div>
            </li>
            <li>
              <div>亏损平仓线</div>
              <div>{{close}}</div>
            </li>
          </ul>
        </div>
        <div class="history_title second">
          <div style="text-align: left;margin-bottom: 10px;font-weight: 700;color: #666;">合约明细</div>
          <ul>
            <li>
              <div>
                策略资金：
                <span style="font-weight: 600;">{{total}}</span>
              </div>
              <div>开始时间：{{time[0]}}</div>
            </li>
            <li>
              <div>
                交易品种：
                <span style="font-weight: 600;">
                  <span style="color: #566B96;">{{type}}</span>
                </span>
              </div>
              <div>结束时间：{{time[1]}}</div>
            </li>
            <li>
              <div>
                交易盈亏：
                <span v-bind:style="profit>0?'color: #D02E27':'color: #3F7A21;'">{{profit>0?profit:loss}}</span>
              </div>
              <div>管理费：{{manage}}元</div>
            </li>
          </ul>
        </div>
        <div class="history_title second">
          <div style="text-align: left;overflow: hidden;margin-bottom: 10px;font-weight: 700;">
            <span style="color: #666;">交易盈利分配</span>
            <span style="float: right;color: #999;font-size: 14px;font-weight: 700;">已结算</span>
          </div>
          <ul>
            <li>
              <div>
                盈利分配：
                <span style="font-weight: 600; color: #D02E27;">{{profit}}</span>
              </div>
            </li>
            <li>
              <div>
                亏损赔付：
                <span style="font-weight: 700;color: #999;">{{loss}}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="history_title second third">
          <div style="text-align: left;overflow: hidden;margin-bottom: 10px;font-weight: 700;">
            <span style="color: #666;">履约金结算</span>
            <span style="float: right;color: #999;font-size: 14px;">已结算</span>
          </div>
          <ul>
            <li>
              <div>
                冻结：
                <span style="font-weight: 600; color: #0D268D;">{{bond}}</span>
              </div>
            </li>
            <li>
              <div>
                扣减：
                <span style="font-weight: 700;color: #999;">{{deduction}}</span>
              </div>
            </li>
            <li>
              <div>
                解冻：
                <span style="font-weight: 700;color: #333;">{{thaw}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="history_apply">历史交易<a href="javascript:void(0);" class="text_red_color" @click="getCapitalData">(点击查看资金明细)</a></div>
    <ul class="entrust_ul2" >
      <li class="entrust_li1" style="background-color: #0D268D !important;">
        <span>股票名称</span>
        <span>买卖方向</span>
        <span>成交股数</span>
        <span>成交价格</span>
        <span>成交状态</span>
        <!-- <span>成交市值</span> -->
        <span>成交时间</span>
      </li>
      <li v-for="(item,index) in trade" :key="index">
        <span>
          <small class="font_weigth">{{item.name}}</small> ({{item.code}})
        </span>
        <span style="color: #3F7A21;">{{item.type}}</span>
        <span>{{item.number}}</span>
        <span>
          ￥
          <small style="color:#3F7A21">{{item.price}}</small>
        </span>
        <span style="color: #666;">{{item.status}}</span>
        <!-- <span>{{item.number}}</span> -->
        <span>{{item.time}}</span>
      </li>
    </ul>
    <el-dialog title="对账单" :visible.sync="capitalState">
      <el-table
        height="500px"
        size="small"
        border
        :data="capitalData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="time"
          label="时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="股票"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          label="金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="余额"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="button_blue_color" @click="capitalState = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Strategyhistorydetails",
  data() {
    return {
      name: "", //策略名称
      order: "", //策略单号
      time: ["", ""], //策略时间
      proportion: "", //盈亏比例
      profit: "", //盈利金额
      loss: "", //亏损金额
      deduction: "", //扣除数量
      thaw: "", //解冻数量
      total: "", //总策略资金
      manage: "", //管理费
      type: "", //交易品种
      capital_total: "", //配资金额
      apply_quota: "", //申请金额
      bond: "", //保证金
      divided: "", //盈利分配
      warning: "", //预警线
      close: "", //平仓线
      trade: [], //交易记录
      capitalState:false,
      capitalData:[]
    };
  },
  mounted: function() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_detailed",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.name = res.data.data.info.name;
            that.order = res.data.data.info.order;
            that.time = res.data.data.info.time.split("~");
            that.proportion = res.data.data.info.proportion;
            that.profit = res.data.data.info.profit;
            that.deduction = res.data.data.info.deduction;
            that.total = res.data.data.info.total;
            that.manage = res.data.data.info.manage;
            that.type = res.data.data.info.type;
            that.capital_total = res.data.data.info.capital_total;
            that.apply_quota = res.data.data.info.apply_quota;
            that.bond = res.data.data.info.bond;
            that.divided = res.data.data.info.divided;
            that.warning = res.data.data.info.warning;
            that.close = res.data.data.info.close;
            that.loss = res.data.data.info.loss;
            that.thaw = res.data.data.info.thaw;
            that.trade = res.data.data.trade;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getCapitalData(){
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            'nozzle': 'capital_log',
            'token': window.sessionStorage.getItem('token'),
            'cid': sessionStorage.getItem("cid")
          }
        }).then(res => {
        if (res.data.code == 1) {
          that.capitalData = res.data.data;
          that.capitalState = true;
        } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>
<style scoped>
.capital_p1 > a:nth-child(1) {
  border: 0;
}
.transport {
  width: 1000px;
  border: 1px solid #ddd;
  margin-top: 20px;
}
.tranport_title {
  height: 85px;
  line-height: 85px;
  background-color: #f3f4f9;
  font-size: 16px;
  font-weight: 700;
  padding-left: 30px;
}
.tranport_content {
  width: 100%;
  height: 694px;
}
.history_title {
  margin: 40px;
  padding-bottom: 24px;
  border-bottom: 1px solid #ddd;
}
.history_title .first {
  list-style: none;
  margin: 40px 0;
}
.history_title ul {
  overflow: hidden;
}
.history_title ul li {
  width: 30%;
  float: left;
  text-align: center;
  line-height: 40px;
}
.second {
  border-bottom: 1px dashed #ddd;
}
.third {
  border: 0;
}
.history_apply {
  width: 100%;
  height: 45px;
  line-height: 45px;
  margin: 40px 0 20px 0;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
}
.entrust_ul2 {
  width: 100%;
}
.entrust_ul2 > li > span:nth-child(1) {
  width: 160px;
  margin-left: 25px;
}
.entrust_ul2 > li > span:nth-child(2) {
  width: 97px;
}
.entrust_ul2 > li > span:nth-child(3) {
  width: 124px;
}
.entrust_ul2 > li > span:nth-child(4) {
  width: 125px;
}
.entrust_ul2 > li > span:nth-child(5) {
  width: 123px;
}
.entrust_ul2 > li > span:nth-child(6) {
  width: 140px;
}
.entrust_ul2 > li > span:nth-child(7) {
  width: 190px;
}
</style>





// WEBPACK FOOTER //
// src/components/strategyhistorydetails.vue